import React from "react";

const TableTdViewDetail = ({url, lang, objectName}) => {
    return (
        <td>
            <a href={url ?? ''} className="d-flex btn btn-secondary pr-1 pl-1 btn--small">
                <h6 className="view-order text-white">
                    {lang.view}
                    {objectName ?? ''}
                </h6>
            </a>
        </td>
    )
}

export default TableTdViewDetail;